<template>
  <el-dialog title="选择文件夹" :visible.sync="formVisible" :close-on-click-modal="true" width="80%">
    <!--工具条-->
    <el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
      <el-form :inline="true" :model="listQuery">
        <el-form-item>
          <el-input v-model="listQuery.q" placeholder="搜索"></el-input>
        </el-form-item>
        <el-form-item>
          <el-checkbox v-model="listQuery.isme" v-show="boxid&&boxid!=''">只看自己</el-checkbox>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" v-on:click="getList()">查询</el-button>
        </el-form-item>
      </el-form>
    </el-col>
    <el-col :span="24" style="margin-bottom: 20px;">
      <el-table :data="tableData" v-loading="listLoading" element-loading-text="Loading" border highlight-current-row>
        <!-- <el-table-column label="状态" align="center" width="100px">
                                <template slot-scope="{row}">
                                <span>{{ row.Stats }}</span>
</template>
                        </el-table-column> -->
        <el-table-column label="名称" align="left">
          <template slot-scope="{row}">
            <a :href="'http://jazpan.com/box/' + row.Id" target="_blank">
              <img class="flicon" src="//static.jazpan.com/img/flbox.png" />{{ row.Name }}
            </a>
          </template>
        </el-table-column>
        <el-table-column label="作者" align="center" width="120px">
          <template slot-scope="{row}">
            <a :href="'http://jazpan.com/user/' + row.Uid" target="_blank">{{ row.infoMap.nick }}</a>
          </template>
        </el-table-column>
        <el-table-column label="浏览" align="center" width="120px">
          <template slot-scope="{row}">
            <span>{{ row.Views }}</span>
          </template>
        </el-table-column>
        <el-table-column label="时间" align="center" width="160px">
          <template slot-scope="{row}">
            <span>{{ row.Timestr }}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" width="200px">
          <template slot-scope="{row}">
            <el-button-group>
              <el-button size="small" type="primary" @click="handlerAdd(row)" :disabled="row.infoMap.inBox">添加
              </el-button>
            </el-button-group>
          </template>
        </el-table-column>
      </el-table>

      <div style="text-align:right;margin-top:50px;">
        <el-pagination background layout="prev, pager, next" @current-change="getList" :current-page="pgpage"
          :page-count="pgpages">
        </el-pagination>
      </div>
    </el-col>
    <!--工具条-->
    <div slot="footer" class="dialog-footer">
      <el-button @click.native="formVisible = false">完成</el-button>
      <!-- <el-button type="primary" @click.native="formSubmit" :loading="formLoading">确认</el-button> -->
    </div>
  </el-dialog>
</template>


<script>
import util from '@/common/js/util'
export default {
  data () {
    return {
      boxid: '',
      fileid: '',
      formVisible: false,
      formLoading: false,
      listLoading: false,
      pgpage: 1,
      pgpages: 1,
      listQuery: {},
      tableData: []
    }
  },
  mounted () {
    // this.getList();
  },
  methods: {
    show (bid, fid) {
      if (bid)
        this.boxid = bid;
      else if (fid)
        this.fileid = fid;
      else
        return;
      this.pgpage = 1;
      this.pgpages = 1;
      this.listQuery = {
        q: '',
        isme: true,
        page: 1
      };
      this.formVisible = true;
      this.getList();
    },
    getFlSize: util.getFlSize,
    getList (pg) {
      this.listLoading = true;
      let pars = this.listQuery;
      pars.boxid = this.boxid;
      pars.page = pg || this.pgpage;
      this.$post('/user/box/page', pars).then(res => {
        this.listLoading = false;
        this.pgpage = res.data.Page;
        this.pgpages = res.data.Pages;
        this.tableData = res.data.Data;
        // this.$message('退出成功');
      }).catch(err => {
        this.listLoading = false;
        this.$message({
          message: err.response ? err.response.data || '服务器错误' : '网络错误',
          type: 'error'
        });
      });
    },
    handlerAdd (et) {
      if (this.boxid && this.boxid != '')
        this.handlerAddBox(et);
      if (this.fileid && this.fileid != '')
        this.handlerAddFile(et);
    }, handlerAddBox (et) {
      this.$post('/user/boxinfoups', { boxid: this.boxid, xid: et.Xid, sort: 10, isadd: true }).then(res => {
        et.infoMap.inBox = true;
        this.$message('添加成功');
        this.$emit('submitOK');
        this.$forceUpdate();
      }).catch(err => {
        this.$message({
          message: err.response ? err.response.data || '服务器错误' : '网络错误',
          type: 'error'
        });
      });
    }, handlerAddFile (et) {
      this.$post('/user/boxinfoup', { boxid: et.Xid, xid: this.fileid, sort: 10, isadd: true }).then(res => {
        et.infoMap.inBox = true;
        this.$message('添加成功');
        this.$emit('submitOK');
        this.$forceUpdate();
      }).catch(err => {
        this.$message({
          message: err.response ? err.response.data || '服务器错误' : '网络错误',
          type: 'error'
        });
      });
    }
  }
};
</script>

<style scoped>
.tmpdesc {
  margin-left: 10px;
  color: #d0d0d0;
}
</style>




// WEBPACK FOOTER //
// BoxSelForm.vue?74688ec5